import React, { useState, useContext } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  TextField,
  Button,
  DialogActions,
} from '@material-ui/core';
import validator from 'validator';

import { auth } from '../utils/firebase';
import { AppContext } from '../context/AppContext';

export default function ResetPassword({ open, setOpen }) {
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');

  const { snack: _snack, isLoading: _isLoading } = useContext(AppContext);

  const setSnack = _snack[1];
  const [isLoading, setIsLoading] = _isLoading;

  // const Transition = forwardRef(function Transition(props, ref) {
  //   return <Slide direction='up' ref={ref} {...props} />;
  // });

  const handleChange = (e) => {
    const { value } = e.target;
    setEmail(value);

    if (!value) {
      setEmailError('Email is required');
    } else if (!validator.isEmail(value)) {
      setEmailError('Email is invalid');
    } else {
      setEmailError('');
    }
  };

  const sendResetLink = () => {
    setIsLoading(true);
    auth
      .sendPasswordResetEmail(email)
      .then(function () {
        // Email sent.
        setIsLoading(false);
        setOpen(false);
        setSnack({
          open: true,
          status: 'success',
          message: 'A reset link has been sent to your email address',
        });
      })
      .catch(function (err) {
        // An error happened.
        setIsLoading(false);
        if (err.code === 'auth/user-not-found') {
          setSnack({
            open: true,
            status: 'error',
            message: 'A user with that email address was not found',
          });
        } else {
          setSnack({
            open: true,
            status: 'error',
            message: 'An error occured! Please try again',
          });
        }
      });
  };

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby='form-dialog-title'
      // TransitionComponent={Transition}
      keepMounted
      disableBackdropClick={isLoading}
    >
      <DialogTitle id='form-dialog-title'>Reset Password</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Enter the email address you used to create your account
        </DialogContentText>
        <TextField
          autoFocus
          margin='dense'
          id='name'
          label='Email Address'
          type='email'
          value={email}
          onChange={handleChange}
          fullWidth
          error={emailError ? true : false}
          helperText={emailError}
          disabled={isLoading}
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => setOpen(false)}
          color='primary'
          disabled={isLoading}
        >
          Cancel
        </Button>
        <Button
          onClick={sendResetLink}
          color='primary'
          disabled={!email || emailError || isLoading ? true : false}
        >
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
}
